import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SommeAssicurateComponent } from './somme-assicurate.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SommaAssicurataFormComponent } from './form/form.component';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { SommeAssicurateRoutingModule } from './somme-assicurate-routing.module';

@NgModule({
  declarations: [SommeAssicurateComponent, SommaAssicurataFormComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
    SommeAssicurateRoutingModule,
  ],
  exports: [SommeAssicurateComponent],
})
export class SommeAssicurateModule { }
